/**
 * 定义一些全局变量 用于不同环境的判断
 * https: //test.ipdc.itcgb.cn
 */

//TODO:全局开关
const PRODUCT = false; //是否是生产环 用于接口请求判断
const INCHANGECONTENT = false;//是否对页面文字可修改
const GETUSERACTION = true;//是否需要开启用户行为统计
const SIGNLRADRESS =process.env.ENV_SIGNLRADRESS ; //SIGNLR 服务地址
export default {
  PRODUCT,
  INCHANGECONTENT,
  GETUSERACTION,
  SIGNLRADRESS,
}
